module.exports = __webpack_public_path__ + "static/royalfarms-861644260fae3880bda42bc35b369496.png";